import React, {PropsWithChildren, useEffect, useState} from "react";
import {twMerge} from "tailwind-merge";
import {Alert, AlertType} from "./Alert";

interface SnackBarProps extends PropsWithChildren<unknown> {
  className?: string;
}

interface Message {
  text: string;
  type: AlertType;
}

type Context = {
  messages: Message[];
  push: (message: Message) => void;
  clear: () => void;
};

export const SnackBarContext = React.createContext<Context>({
  messages: [],
  push: () => Object,
  clear: () => Object,
});

export const Snackbar = ({children, className}: SnackBarProps) => {
  const [messages, setMessages] = useState<Message[]>([]);
  const [startIdx, setStartIdx] = useState<number>();

  useEffect(() => {
    const timer = setTimeout(() => setStartIdx(undefined), 3000);
    return () => clearTimeout(timer);
  }, [messages]);

  const push = (message: Message) => {
    const newMessages = [...messages, message];
    setMessages(newMessages);
    if (startIdx === undefined) {
      setStartIdx(newMessages.length - 1);
    }
  };

  const clear = () => {
    setMessages([]);
  };

  return (
    <SnackBarContext.Provider value={{messages, push, clear}}>
      {children}
      {startIdx !== undefined && (
        <ul
          className={twMerge(
            "fixed z-50 flex flex-col items-center max-h-screen gap-2 overflow-y-auto",
            "text-sm transform -translate-x-1/2 top-0 pt-2 left-1/2 scroll-hidden",
            className,
          )}
        >
          {messages.slice(startIdx).map((message, i) => (
            <li key={i}>
              <Alert type={message.type} className="text-center">
                {message.text}
              </Alert>
            </li>
          ))}
        </ul>
      )}
    </SnackBarContext.Provider>
  );
};
